import Component from '../core/Component'

export const defaults = {
    file: null,
    onRemove: () => {}
}

export default class MarketFormFileItem extends Component {
    constructor(element, options = {}) {
        super(element, defaults)

        this.options = options

        this.ref = {
            remove: null
        }
    }

    prepare() {
        this.ref.remove.addEventListener('click', ::this.handleRemove)
    }

    handleRemove(event) {
        event.preventDefault()

        if (this.options.file && this.options.onRemove) {
            this.options.onRemove(this.options.file)
        }

        this.element.parentNode.removeChild(this.element)
    }
}